module.exports = __webpack_public_path__ + "img/get.edb4d924.png";